<template>
  <div class="publishDialog">
    <el-dialog
      v-model="curDialogVisible"
      center
      :show-close="false"
      :close-on-click-modal="false"
      @closed="cancelDo"
    >
      <div class="bg">
        <el-form ref="ruleForm" :hide-required-asterisk="true" :model="publishModel.ruleForm" :rules="publishModel.rules">
          <el-form-item v-for="item in publishModel.itemList" :prop="item.name.toLocaleLowerCase()" :key="item" >
            <div class="input-box">
              <div class="line"></div>
              <div class="left"> {{ item.name }}</div>
              <el-input
                class="right"
                :placeholder="item.placeHolder"
                v-model="publishModel.ruleForm[item.name]"
                @input="changeName"
              ></el-input>
            </div>
          </el-form-item>
          <div class="btn-box">
            <el-button class="btn btn1" @click="cancelDo">Cancel</el-button>
            <el-button class="btn btn2" @click="submitForm('ruleForm')">Confirm</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "publishDialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    dialogVisible(val) {
      this.curDialogVisible = val;
    },
    model(val) {
      this.publishModel.ruleForm = val;
    },

  },
  data() {
    return {
      ruleForm: {
          tool: "",
          verison: "",
          description: ""
        },
      curDialogVisible: false,
      inputName: "",
      inputField: "",
      showNameMesg: false,
      showFieldMesg: false,
      publishModel: {
        ruleForm: {
          tool: "",
          verison: "",
          description: ""
        },
        itemList: [
        {
          name: "tool",
          placeHolder: "The tool is written here",
        },
        {
          name: "verison",
          placeHolder: "The version is written here",
        },
        {
          name: "description",
          placeHolder: "The description is written here",
        },
        ], 
        rules: {
          tool: [{ required: true, message: "Please Enter the Tool", trigger: "blur" }],
          verison: [{ required: true, message: "Please Enter The version", trigger: "blur" }],
          description: [{ required: true, message: "Please Enter The Description", trigger: "blur" }],
        }
      }
    };
  },
  methods: {
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log("valid = ", valid)
            this.$emit("publishSubmitDo", this.publishModel.ruleForm)
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      cancelDo() {
        this.$emit("cancelDo")
      }
  },
  created() {},
};
</script>
<style lang='less' scoped>
.bg {
  display: flex;
  flex-direction: column;
}

.input-box {
  display: flex;
  align-items: center;
  margin-top: 10px;
  .line {
    width: 5px;
    height: 40px;
    background-color: #fbad15;
  }
  .left {
    width: 90px;
    margin-left: 24px;
    color: #383838;
    font-size: 14px;
    font-weight: bold;
    // background-color: red;
  }
  .right {
    width: 460px;
  }
}

.namemesg {
  margin-left: 122px;
  font-size: 12px;
  color: red;
}

.btn-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 45px;
  padding-right: 40px;

  .btn {
    height: 40px;
    width: 160px;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn1 {
    background-color: #f5f5f5;
    border: 1px solid #a6a6a6;
    color: #a6a6a6;
    margin-right: 20px;
  }
  .btn2 {
    background-color: #0052d9;
    border: 1px solid #0052d9;
    color: #ffffff;
  }
}

:deep(.el-dialog--center .el-dialog__body) {
  padding: 0px 0px 30px;
}

:deep(.el-dialog) {
  border-radius: 8px;
  width: 620px !important;
}

:deep(.el-form-item__error) {
  left: 120px !important;
}
</style>